import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as i, openBlock as d, normalizeClass as l, createElementVNode as n } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconShare2",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7 2.5a2 2 0 1 1 .579 1.407l-2.654 1.55a2.001 2.001 0 0 1 0 1.087L7.581 8.09a2 2 0 1 1-.505.863L4.42 7.407a2 2 0 1 1 0-2.815l2.654-1.548A2.001 2.001 0 0 1 7 2.5Zm1 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM2 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm6 3.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z",
  fill: "currentColor"
}, null, -1), m = [
  _
];
function u(e, h, r, f, p, a) {
  return d(), i("svg", {
    "aria-label": r.ariaLabel,
    class: l([a.iconSizeClass, "d-icon d-icon--share-2"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Share 2",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, m, 10, c);
}
const v = /* @__PURE__ */ o(s, [["render", u]]);
export {
  v as default
};
//# sourceMappingURL=share-2.js.map
